import { render, staticRenderFns } from "./PresenceSupervisorHelpAlertCount.vue?vue&type=template&id=1790ca4e"
import script from "./PresenceSupervisorHelpAlertCount.vue?vue&type=script&lang=js"
export * from "./PresenceSupervisorHelpAlertCount.vue?vue&type=script&lang=js"
import style0 from "./PresenceSupervisorHelpAlertCount.vue?vue&type=style&index=0&id=1790ca4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports